export const getCountryCodeFromLocale = (locale: string): string => {
  return locale.split('_')[1];
};
